export enum ConstructionCredits {
    None = 0,
    CreditMemoOnly = 1,
    CreditMemoAndCorrection = 2
    }